import EditReservation from '@/components/edit-reservation';

export default EditReservation;
